/* eslint-disable no-console */
import * as Sentry from '@sentry/vue';
import flagsmith from 'flagsmith';

const DEFAULT_TRACES_SAMPLE_RATE = 1.0;
const DEFAULT_REPLAYS_SESSION_SAMPLE_RATE = 0.1;
const DEFAULT_REPLAYS_ERROR_SAMPLE_RATE = 1.0;


/**
 * Get user information from storage
 * @returns {Object|null}
 */
const getUserInfo = () => {
  try {
    const email = localStorage.getItem('email');
    const userCompanyId = localStorage.getItem('userCompanyId');
    const companyName = localStorage.getItem('companyName');

    return {
      email: email || null,
      'User Company ID': userCompanyId || null,
      'Company Name': companyName || null,
    };
  } catch (error) {
    console.warn('Error getting user info:', error);
    return null;
  }
};

/**
 * Initialize Sentry for error tracking and performance monitoring
 * @param {Vue} Vue - Vue constructor
 * @param {Object} router - Vue router instance (optional)
 */
export default (Vue, router = null) => {
  const environment = process.env.NODE_ENV || 'development';
  const isDevelopment = environment === 'development';
  const dsn = process.env.SENTRY_DSN;

  if (!dsn) {
    console.error('Sentry configuration error: Missing DSN');
    return;
  }

  const sentryConfig = {
    dsn,
    environment,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: isDevelopment ? 0.1 : (Number(flagsmith.getValue('sentry_traces_sample_rate')) || DEFAULT_TRACES_SAMPLE_RATE),
    replaysSessionSampleRate: isDevelopment ? 0.01 : (flagsmith.getValue('sentry_replays_session_sample_rate') || DEFAULT_REPLAYS_SESSION_SAMPLE_RATE),
    replaysOnErrorSampleRate: isDevelopment ? 0.1 : (flagsmith.getValue('sentry_replays_error_sample_rate') || DEFAULT_REPLAYS_ERROR_SAMPLE_RATE),
    debug: isDevelopment,
    sendDefaultPii: false,
    autoSessionTracking: !isDevelopment,
    transport: isDevelopment
      ? undefined
      : Sentry.makeBrowserOfflineTransport(Sentry.makeFetchTransport),
  };

  try {
    Sentry.init({
      Vue,
      ...sentryConfig,
    });

    console.log(`Sentry initialized for ${environment} environment with Flagsmith configuration`);

    // // Set initial user context if available
    const userInfo = getUserInfo();
    if (userInfo) {
      Sentry.setUser(userInfo);
    }
  } catch (error) {
    console.error('Failed to initialize Sentry:', error);
  }
};



// WEBPACK FOOTER //
// ./src/configs/sentry.js